"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _sanitizeHtmlReact = _interopRequireDefault(require("sanitize-html-react"));

var _styles = require("./styles");

var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Simple component to show a tooltip when hovering over a help icon
 */
const TooltipToggle = ({
  className,
  style,
  character,
  content,
  ...otherProps
}) => {
  const ref = (0, _react.useRef)();
  const id = `tooltip-${(0, _uuid.v4)()}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.TooltipWrapper, {
    className: `rui-tootltip-toggle ${className}`.trim(),
    style: style,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TooltipInner, {
      ref: ref,
      "data-tip": (0, _sanitizeHtmlReact.default)(content),
      "data-for": id,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TooltipLabel, {
        children: character
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
      id: id,
      ...otherProps
    })]
  });
};

TooltipToggle.defaultProps = {
  character: '?'
};
TooltipToggle.propTypes = {
  character: _propTypes.default.string,
  content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node]).isRequired
};
var _default = TooltipToggle;
exports.default = _default;